export type RangePreset = 'today' | '7d' | '30d' | 'last-month' | 'month' | 'year' | 'all' | 'custom';
export const analyticsAllTimeStart = '2026-07-01';

const israelDateFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Jerusalem',
  year: 'numeric', month: '2-digit', day: '2-digit',
});

export function israelToday() {
  const parts = Object.fromEntries(israelDateFormatter.formatToParts().map((part) => [part.type, part.value]));
  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function addDays(date: string, days: number) {
  const value = new Date(`${date}T12:00:00Z`);
  value.setUTCDate(value.getUTCDate() + days);
  return value.toISOString().slice(0, 10);
}

export function rangeForPreset(preset: Exclude<RangePreset, 'custom'>) {
  const today = israelToday();
  const toExclusive = addDays(today, 1);
  if (preset === 'today') return { from: today, toExclusive };
  if (preset === 'all') return { from: analyticsAllTimeStart, toExclusive };
  if (preset === 'year') return { from: `${today.slice(0, 4)}-01-01`, toExclusive };
  if (preset === 'month') return { from: `${today.slice(0, 7)}-01`, toExclusive };
  if (preset === 'last-month') {
    const previousMonth = addDays(`${today.slice(0, 7)}-01`, -1);
    return { from: `${previousMonth.slice(0, 7)}-01`, toExclusive: `${today.slice(0, 7)}-01` };
  }
  const days = Number.parseInt(preset, 10);
  return { from: addDays(toExclusive, -days), toExclusive };
}

export function displayRange(from: string, toExclusive: string) {
  const formatter = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  return `${formatter.format(new Date(`${from}T12:00:00Z`))} – ${formatter.format(new Date(`${addDays(toExclusive, -1)}T12:00:00Z`))}`;
}
